import type { FC, HtmlHTMLAttributes } from "react";

import * as stylex from "@stylexjs/stylex";

import { type OmitStyles, type PropsWithStyleX, globalFontStyles } from "../../styles/tokens.stylex";

export type ITypography = OmitStyles<HtmlHTMLAttributes<HTMLElement>> &
    PropsWithStyleX & {
        textElement?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "li";
        fontStyle?: keyof typeof globalFontStyles;
        children?: React.ReactNode;
    };

export const Typography: FC<ITypography> = ({
    textElement = "p",
    fontStyle = "p",
    styleX,
    children,
    ...props
}) => {
    const Element = textElement;
    const styles = stylex.props(globalFontStyles.primaryText, globalFontStyles[fontStyle], styleX);

    return (
        <Element {...props} {...styles}>
            {children}
        </Element>
    );
};
